module.exports = __webpack_public_path__ + "img/4b.cde836db.png";